import React from 'react';
import { Tooltip, TooltipProps, withStyles } from '@material-ui/core';

const StyledTooltip = withStyles((theme) => ({
  tooltip: {
    minWidth: 250,
    fontSize: theme.typography.pxToRem(12),
  },
}))(Tooltip);

// Custom wrapper to inject default props
export const CustomChipTooltip: React.FC<TooltipProps> = (props) => {
  return <StyledTooltip enterTouchDelay={0} leaveTouchDelay={5000} {...props}/>;
};
